import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useMemo, useState } from 'react';
const ApiContext = createContext(undefined);
export const ApiProvider = ({ children }) => {
    const [useMockApi, setUseMockApi] = useState(() => {
        const stored = localStorage.getItem('useMockApi');
        return stored === null ? false : stored === 'true';
    });
    const value = useMemo(() => ({ useMockApi, setUseMockApi }), [useMockApi]);
    return _jsx(ApiContext.Provider, { value: value, children: children });
};
export const useApiContext = () => {
    const ctx = useContext(ApiContext);
    if (!ctx)
        throw new Error('useApiContext must be used within ApiProvider');
    return ctx;
};
